export enum EndpointsInvoices {
  ElectricityInvoices = "/invoices/",
}

export enum EndpointsFilter {
  FieldParams = "/filter/params",
}